// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "capsuleHotel-2lNr7";
var _5 = "descriptions-2dJ13";
var _6 = "main-1p1yS";
var _7 = "service_active-120Lg";
var _8 = "paper-3l8id";
var _9 = "header-3DYgt";
var _a = "slider-Fo_ye";
var _b = "slide-2l2y9";
var _c = "dots-3zySe";
var _d = "modal_root-2aaND";
var _e = "modal_scrollBody-1TNvR";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "capsuleHotel", _5 as "descriptions", _6 as "main", _7 as "service_active", _8 as "paper", _9 as "header", _a as "slider", _b as "slide", _c as "dots", _d as "modal_root", _e as "modal_scrollBody" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "capsuleHotel": _4, "descriptions": _5, "main": _6, "service_active": _7, "paper": _8, "header": _9, "slider": _a, "slide": _b, "dots": _c, "modal_root": _d, "modal_scrollBody": _e }
